import { datadogLogs } from '@datadog/browser-logs';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import LogRocket from 'logrocket';

import { useStorage } from '~Components/Storage';
import { useLogger, useSelector } from '~Hooks';

export const LogManager = () => {
  const location = useLocation();
  const [storage, _, loadingStorage] = useStorage();
  const [{ selectedKDSStation }] = useStorage();
  const logger = useLogger('initialization');
  const venueId = useSelector((state) => state.venueId);

  const user = useSelector((state) => state.user);
  const selectedKDSStationName = useSelector((state) => state.stations)?.find(
    (s) => s.id === selectedKDSStation,
  )?.name;
  const bongPrintingHalted = useSelector((state) => state.BongPrintingHalted);

  const [logRocketInitialized, setLogRocketInitialized] = useState(false);

  useEffect(() => {
    logger.info(`Booting device...`, {
      deviceName: storage.taxComplianceDeviceName,
      KDSStation: selectedKDSStationName,
      location: location.pathname,
    });
  }, []);

  // Keep settings in sync with datadog
  useEffect(() => {
    if (loadingStorage) {
      return;
    }

    datadogLogs.addLoggerGlobalContext('storedSettings', storage);

    if (storage.taxComplianceDeviceName) {
      datadogLogs.addLoggerGlobalContext('device', storage.taxComplianceDeviceName);
    }
  }, [storage, loadingStorage]);

  // Add bongPrintingHalted to datadog settings
  useEffect(() => {
    datadogLogs.addLoggerGlobalContext('bongPrintingHalted', bongPrintingHalted);
  }, [bongPrintingHalted]);

  // Enable LogRocket if enabled in settings
  useEffect(() => {
    if (loadingStorage) {
      return;
    }

    if (storage.enableLogRocket && !logRocketInitialized) {
      LogRocket.init(process.env.LOGROCKET_ID!);
      logger.info(`LogRocket logging enabled for ${user?.name}`, {
        user,
      });
      setLogRocketInitialized(true);
    }

    if (storage.enableLogRocket && user) {
      LogRocket.identify(user.id, {
        name: user.name,
        email: user.email || '',
        company: user.company.name,
        venueId: venueId!,
      });
    }
  }, [storage.enableLogRocket, loadingStorage, user, venueId]);

  // Set LogRocket session URL in datadog
  useEffect(() => {
    datadogLogs.addLoggerGlobalContext('logRocketSessionUrl', LogRocket.sessionURL);
  }, [logRocketInitialized]);

  return null;
};
